<template>
    <div class='student-overview'>
        <page-top :title="$t('pages.overview.title')" :background="'#35b72a'" >
            <div class="box is-radiusless is-borderless" />
        </page-top>

        <div class="section">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="card">
                            <header class="card-header">
                                <div class=" card-header-title">
                                    <h2 class="is-size-4">Vejledning</h2>
                                </div>
                            </header>

                            <div class="card-content">
                                <p>Som hjælp til at kommunikere effektivt med kunder, har vi lavet nogle briefing-skemaer du kan benytte i dialogen med kunden, så du kommer bedst muligt fra start i relationen. Du finder skemaerne herunder.
                                    <br><br> Vi opfordrer til, at du altid også ringer til kunden, for at komme godt igang med opgaven.</p>
                                <br>
                                <a target="_blank" rel="noreferrer" href="https://drive.google.com/drive/folders/1Mhs0xSYzzj19zEy7-mV9DrTv-UuKCird?usp=sharing" class="button is-info">Find skemaerne her</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <project-overview-list />
                    </div>

                    <div class="column">
                        <conversation-overview-list />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .student-overview {
        background: $background-blueish;
    }
</style>

<script>
    import ProjectOverviewList from '@/taskflex/projects/components/OverviewList';
    import PageTop from '@/global/components/PageTop';
    import ConversationOverviewList from '@/taskflex/conversations/components/OverviewList';

    export default {
        data() {
            return {
                student: null,
                page: null,
            };
        },

        components: {
            ConversationOverviewList,
            PageTop,
            ProjectOverviewList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/pages/Overview.vue